import { resolveFacilityIcon } from './facilityIcon';

export const IconMapper = (icon: string, size: number) => {
  const Icon = resolveFacilityIcon(icon);
  return <Icon size={size} />;
};
